import { useOutsideClick } from "@/hooks/useOutsideClick";
import { AnimatePresence, motion } from "framer-motion";
import Image from 'next/image';
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import 'react-toastify/dist/ReactToastify.css';

const LimitedAccessModal = ({
    isOpen,
    onClose,
    baseAssetsApi
}: {
    baseAssetsApi: string;
    isOpen: boolean;
    onClose: () => void;
}) => {
    const ref = useOutsideClick(() => onClose());

    const [isReady, setIsReady] = useState(false)


    useEffect(() => {
        if (typeof window !== 'undefined' && document) {
            setIsReady(true)
        }
    }, [])

    if (!isReady) {
        return null;
    }

    return isOpen && isReady && createPortal(
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div className="fixed bottom-0 left-0 right-0 top-0 z-[100] before:absolute before:right-0 before:top-0 before:z-10 before:h-full before:w-full before:bg-gray-700/50">
                        {" "}
                    </motion.div>
                    <motion.div
                        ref={ref}
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
                        exit={{ y: 50, opacity: 0 }}
                        transition={{
                            duration: 0.3,
                            type: "inertia",
                        }}
                        className="fixed bottom-0 py-4 lg:py-10 flex justify-center flex-col items-center left-0 right-0 top-0 z-[110] m-auto  w-full h-full max-h-dvh md:h-fit  max-w-2xl md:rounded-2xl bg-white  overflow-y-auto"
                    >
                        <div className='mb-10 w-1/2'>
                            <Image className='' alt="Planingo" width={400} height={400} src={`https://planingo.ai/wp-content/uploads/2024/08/adventure.png`} />
                        </div>
                        <p className='text-neutral-800 text-xl font-semibold py-4 text-center'> Limited Section Access</p>
                        <p className='text-center text-neutral-600 font-normal max-w-md'>You don&lsquo;t have the necessary access to this section. If you believe you need access, please request access using the button below.</p>

                        <div className='flex justify-center gap-2 mt-7'>
                            <button onClick={onClose} className='px-10 border border-neutral-800 py-3.5 rounded-2xl'>
                                Back
                            </button>
                            {/* <button className='px-10 border text-white bg-neutral-800 py-3.5 rounded-2xl'>
                                Request Access
                            </button> */}
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>,
        window.document.body,
    );
};
export default LimitedAccessModal;
